
import { useEnhancedProgressState } from './useEnhancedProgressState';
import { useCollectionGenerationState } from './useCollectionGenerationState';

export function useCollectionCardProgress(collectionId: string) {
  const { data: progressState, isLoading } = useEnhancedProgressState(collectionId);
  const { isGeneratingCollection } = useCollectionGenerationState();

  // Calculate derived values
  const isProcessing = progressState?.isProcessing || isGeneratingCollection(collectionId);
  const progressPercentage = progressState?.percentage || 0;
  const processedItems = progressState?.processed || 0;
  const totalItems = progressState?.total || 1;
  const currentAction = progressState?.action || 'Ready';

  return {
    isProcessing,
    progressPercentage,
    processedItems,
    totalItems,
    currentAction,
    processType: progressState?.processType || 'none',
    status: progressState?.status || 'pending',
    stage: progressState?.stage || 'pending',
    source: progressState?.source || 'initial',
    isLoading,
    error: null,
    lastUpdated: progressState?.lastUpdated || new Date(),
    isCompleted: progressState?.isCompleted || false
  };
}
